<mad-data-table
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [paginationEnabled]="true"
  [pageSizeOptions]="[5, 10, 15, 20, 50]"
  [defaultPageSize]="50"
  [filterEnabled]="true"
  [filterPlaceholder]="'type to search in all columns'"
>
</mad-data-table>
